import type { BuilderContextProvidersData } from '@wix/thunderbolt-symbols'

export const filterContextProvidersForImportMap = (
	contextProviders: BuilderContextProvidersData['contextProviders']
) => {
	return Object.entries(contextProviders).reduce(
		(acc, [type, contextProviderData]) => {
			if (contextProviderData.contextSpecifier?.moduleSpecifier && contextProviderData.componentUrl) {
				acc[contextProviderData.contextSpecifier?.moduleSpecifier] = contextProviderData.componentUrl
			}
			return acc
		},
		{} as Record<string, string>
	)
}
